import React from 'react';
import { createStyles, Icon, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
    createStyles({
        iconLock: {
            marginLeft: 8,
            fontSize: '0.75em',
        },
    }),
);

const LockIcon = React.forwardRef<HTMLElement, {}>((props, ref) => {
    const classes = useStyles();
    return (
        <Icon {...props} fontSize="small" color="primary" className={classes.iconLock} ref={ref}>
            lock
        </Icon>
    );
});

export default LockIcon;
